function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, ref, computed, watch, reactive, toRefs, getCurrentInstance } from "vue";
import store from "@/store";
import { definePropType } from "@types-vue/props";
import { openVisibleDialog } from "../config/dialog";
import { customColumns } from "../config/table";
import { dataBaseInformation, dataStatusInformation, dataLabelInformation, checkedColumnGroups, tableColumnConFun, fragmentProperties } from "../config/table";
import { Operation, TabsType } from "@/views/repository/resource/config/enums";
export default defineComponent({
    name: "operation-modular",
    props: {
        tableListTotal: {
            type: definePropType(Number),
            default: 0
        },
        type: {
            type: definePropType(Number),
            default: 0
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var displayType = ref("list");
        var tablePropVisible = ref(false);
        var isBatchUpload = ref(false);
        var isNeedUpload = ref(true);
        var resource = computed(function() {
            return store.state.resource;
        });
        var dataResourcesInformation = reactive({
            dataColumns: []
        });
        var checkedGroups = reactive({
            baseGroups: checkedColumnGroups.baseGroups,
            resourceGroups: checkedColumnGroups.resourceGroups,
            statusGroups: checkedColumnGroups.statusGroups,
            labelGroups: checkedColumnGroups.labelGroups
        });
        var handleSearch = function() {
            emit("checkedTableColumns", tableColumnConFun(checkedGroups, dataResourcesInformation.dataColumns));
        };
        var handleUploadConfig = function(type) {
            openVisibleDialog();
            resource.value.dialogFormInfo = {
                id: 0,
                operation: type
            };
        };
        var handleCommand = function(command) {
            handleUploadConfig(command);
        };
        var goAssetsFactory = function() {
            window.open("".concat(process.env.AF, "#/editor?type=").concat(props.type));
        };
        watch(function() {
            return resource.value.activeTab;
        }, function(val) {
            // tab：全部、花字库、转场库、滤镜库、动画库、模型库、动作库 不可批量上传
            isBatchUpload.value = [
                TabsType.ALL,
                TabsType.FLOWERWORD,
                TabsType.TRANSITION,
                TabsType.FILTER,
                TabsType.ANIMATION,
                TabsType.MODEL,
                TabsType.ACTION, 
            ].indexOf(val) === -1;
            // tab: 预设库、片段库不可单个、批量上传资源
            isNeedUpload.value = [
                TabsType.PRESETS,
                TabsType.FRAGMENT
            ].indexOf(val) === -1;
            tablePropVisible.value = false;
            dataResourcesInformation.dataColumns = customColumns(val);
            // 片段库的资源属性列默认全选
            if (val === TabsType.FRAGMENT) {
                checkedGroups.resourceGroups = fragmentProperties;
            } else {
                checkedGroups.resourceGroups = checkedColumnGroups.resourceGroups;
            }
            // 音频资源默认增加ai tag标签，其他资源只有资源标签
            if (val === TabsType.AUDIO) {
                checkedGroups.labelGroups = [
                    "tag_names",
                    "ai_tag_names"
                ];
            } else {
                checkedGroups.labelGroups = [
                    "tag_names"
                ];
            }
            handleSearch();
        }, {
            immediate: true
        });
        watch(function() {
            return root.$route;
        }, function() {
            isBatchUpload.value = false;
            isNeedUpload.value = [
                TabsType.PRESETS,
                TabsType.FRAGMENT
            ].indexOf(resource.value.activeTab) === -1;
        }, {
            immediate: true
        });
        return _objectSpreadProps(_objectSpread({}, toRefs(checkedGroups), toRefs(dataResourcesInformation)), {
            TabsType: TabsType,
            displayType: displayType,
            tablePropVisible: tablePropVisible,
            isBatchUpload: isBatchUpload,
            isNeedUpload: isNeedUpload,
            dataBaseInformation: dataBaseInformation,
            dataStatusInformation: dataStatusInformation,
            dataLabelInformation: dataLabelInformation,
            handleSearch: handleSearch,
            handleCommand: handleCommand,
            handleUploadConfig: handleUploadConfig,
            goAssetsFactory: goAssetsFactory,
            ADD_PARTICLE: Operation.ADD_PARTICLE
        });
    }
});
